import axios from "axios";

const KEY = "pp_attribution_v1";
const TTL_MS = 90 * 24 * 60 * 60 * 1000;
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "via", "ref"];

// Captures utm_* / ?via= / ?ref= on first touch (90-day sticky) and logs the
// visit so /admin/launch-kit can attribute traffic + revenue per channel.
export function captureAttribution() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const found = {};
  for (const f of FIELDS) {
    const v = params.get(f);
    if (v) found[f === "ref" ? "utm_source" : f] = v.slice(0, 80);
  }
  if (!Object.keys(found).length) return;
  const existing = getAttribution();
  if (!existing.utm_source && !existing.via) {
    localStorage.setItem(KEY, JSON.stringify({ ...found, captured_at: Date.now() }));
  }
  axios
    .post(`${process.env.REACT_APP_BACKEND_URL}/api/public/track-visit`, {
      ...found,
      path: window.location.pathname,
      referrer: document.referrer || null,
    })
    .catch(() => {});
}

export function getAttribution() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const data = JSON.parse(raw);
    if (Date.now() - (data.captured_at || 0) > TTL_MS) {
      localStorage.removeItem(KEY);
      return {};
    }
    const { captured_at, ...rest } = data;
    return rest;
  } catch {
    return {};
  }
}

export function setAffiliateCode(code) {
  const current = getAttribution();
  localStorage.setItem(KEY, JSON.stringify({ ...current, via: code, captured_at: Date.now() }));
}
